import React from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Sidebar as GlobalAlertsSidebarType } from './ui/index.tsx';

export const LazyGlobalAlertsSidebar = lazyForPaint<typeof GlobalAlertsSidebarType>(() =>
	import(/* webpackChunkName: "async-sidebar-global-alerts" */ './index').then((bundle) => bundle),
);

export const AsyncSidebarEocGlobalAlerts = (): React.JSX.Element => (
	<SidebarBoundary id="eocGlobalAlerts">
		<LazyGlobalAlertsSidebar />
	</SidebarBoundary>
);
